import React, { useState } from 'react';
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
const data = [{
  time: '00:00',
  interventions: 12,
  sla: 95,
  efficiency: 88
}, {
  time: '04:00',
  interventions: 18,
  sla: 92,
  efficiency: 90
}, {
  time: '08:00',
  interventions: 35,
  sla: 96,
  efficiency: 92
}, {
  time: '12:00',
  interventions: 28,
  sla: 94,
  efficiency: 89
}, {
  time: '16:00',
  interventions: 22,
  sla: 97,
  efficiency: 94
}, {
  time: '20:00',
  interventions: 15,
  sla: 95,
  efficiency: 91
}];
export function PerformanceChart() {
  const [chartType, setChartType] = useState<'line' | 'area'>('area');
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-293">
      <div className="flex items-center justify-between mb-6" data-id="element-294">
        <div data-id="element-295">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-296">
            Performance en temps réel
          </h2>
          <p className="text-sm text-gray-500 mt-1" data-id="element-297">Dernières 24 heures</p>
        </div>
        <div className="flex space-x-2" data-id="element-298">
          <button onClick={() => setChartType('area')} className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${chartType === 'area' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-299">
            Area
          </button>
          <button onClick={() => setChartType('line')} className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${chartType === 'line' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-300">
            Line
          </button>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300} data-id="element-301">
        {chartType === 'area' ? <AreaChart data={data} data-id="element-302">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-303" />
            <XAxis dataKey="time" tick={{
          fontSize: 12
        }} stroke="#9ca3af" data-id="element-304" />
            <YAxis tick={{
          fontSize: 12
        }} stroke="#9ca3af" data-id="element-305" />
            <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} data-id="element-306" />
            <Legend data-id="element-307" />
            <Area type="monotone" dataKey="interventions" stackId="1" stroke="#3b82f6" fill="#3b82f6" fillOpacity={0.6} name="Interventions" data-id="element-308" />
            <Area type="monotone" dataKey="sla" stackId="2" stroke="#10b981" fill="#10b981" fillOpacity={0.6} name="SLA %" data-id="element-309" />
          </AreaChart> : <LineChart data={data} data-id="element-310">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-311" />
            <XAxis dataKey="time" tick={{
          fontSize: 12
        }} stroke="#9ca3af" data-id="element-312" />
            <YAxis tick={{
          fontSize: 12
        }} stroke="#9ca3af" data-id="element-313" />
            <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} data-id="element-314" />
            <Legend data-id="element-315" />
            <Line type="monotone" dataKey="interventions" stroke="#3b82f6" strokeWidth={2} name="Interventions" data-id="element-316" />
            <Line type="monotone" dataKey="sla" stroke="#10b981" strokeWidth={2} name="SLA %" data-id="element-317" />
            <Line type="monotone" dataKey="efficiency" stroke="#f59e0b" strokeWidth={2} name="Efficacité %" data-id="element-318" />
          </LineChart>}
      </ResponsiveContainer>
    </div>;
}